import { render, staticRenderFns } from "./NavigationSideHeader.vue?vue&type=template&id=44d90748&scoped=true"
import script from "./NavigationSideHeader.vue?vue&type=script&lang=js"
export * from "./NavigationSideHeader.vue?vue&type=script&lang=js"
import style0 from "./NavigationSideHeader.vue?vue&type=style&index=0&id=44d90748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d90748",
  null
  
)

export default component.exports